// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.recipe-card {
  max-width: 500px;
  margin: 0 auto;
  background: #fbf6ee;
  border: 1px solid #dcc9a3;
  border-radius: 16px;
  overflow: hidden;
}

.recipe-card__hero {
  position: relative;
  height: 160px;
  background: #c97b4a;
}

.recipe-card__hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.recipe-card__hero-placeholder {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #fbf6ee;
  font-size: 0.875rem;
  padding: 0 1rem;
  text-align: center;
}

.recipe-card__body {
  padding: 1.25rem 1.5rem;
}

.recipe-card__title {
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 1.5rem;
  color: #5b3a29;
  margin: 0 0 0.25rem;
}

.recipe-card__subtitle {
  font-size: 0.875rem;
  color: #8a6a4f;
  margin: 0 0 0.875rem;
}

.recipe-card__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.recipe-card__tag {
  background: #e8d7b8;
  color: #5b3a29;
  font-size: 11px;
  padding: 0.125rem 0.625rem;
  border-radius: 9999px;
}

.recipe-card__section {
  border-top: 1px dashed #dcc9a3;
  padding-top: 1rem;
  margin-bottom: 1rem;
}

.recipe-card__section h3 {
  font-size: 0.875rem;
  font-weight: 500;
  color: #5b3a29;
  margin: 0 0 0.5rem;
}

.recipe-card__list {
  font-size: 0.75rem;
  color: #6e5340;
  line-height: 1.9;
  padding-left: 1.125rem;
  margin: 0;
}

.recipe-card__steps {
  line-height: 2;
}

.recipe-card__nutrition {
  display: flex;
  justify-content: space-between;
  background: #f3e9d4;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 11px;
  color: #5b3a29;
}
`, "",{"version":3,"sources":["webpack://./src/styles/RecipeCard.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB","sourcesContent":[".recipe-card {\n  max-width: 500px;\n  margin: 0 auto;\n  background: #fbf6ee;\n  border: 1px solid #dcc9a3;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.recipe-card__hero {\n  position: relative;\n  height: 160px;\n  background: #c97b4a;\n}\n\n.recipe-card__hero img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.recipe-card__hero-placeholder {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n  color: #fbf6ee;\n  font-size: 0.875rem;\n  padding: 0 1rem;\n  text-align: center;\n}\n\n.recipe-card__body {\n  padding: 1.25rem 1.5rem;\n}\n\n.recipe-card__title {\n  font-family: Georgia, 'Times New Roman', serif;\n  font-size: 1.5rem;\n  color: #5b3a29;\n  margin: 0 0 0.25rem;\n}\n\n.recipe-card__subtitle {\n  font-size: 0.875rem;\n  color: #8a6a4f;\n  margin: 0 0 0.875rem;\n}\n\n.recipe-card__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.recipe-card__tag {\n  background: #e8d7b8;\n  color: #5b3a29;\n  font-size: 11px;\n  padding: 0.125rem 0.625rem;\n  border-radius: 9999px;\n}\n\n.recipe-card__section {\n  border-top: 1px dashed #dcc9a3;\n  padding-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.recipe-card__section h3 {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #5b3a29;\n  margin: 0 0 0.5rem;\n}\n\n.recipe-card__list {\n  font-size: 0.75rem;\n  color: #6e5340;\n  line-height: 1.9;\n  padding-left: 1.125rem;\n  margin: 0;\n}\n\n.recipe-card__steps {\n  line-height: 2;\n}\n\n.recipe-card__nutrition {\n  display: flex;\n  justify-content: space-between;\n  background: #f3e9d4;\n  border-radius: 10px;\n  padding: 0.75rem 1rem;\n  font-size: 11px;\n  color: #5b3a29;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
